<script setup lang="ts">
import { useTheme, ThemeInstance } from 'vuetify';
import ThemeToggleFab from "../components/ThemeToggleFab.vue"; // Adjust path if needed
import { computed } from 'vue';

interface Props {
  width?: number;
  background?: string; // Optional, allows overriding default background class
}

const props = defineProps<Props>();

const theme: ThemeInstance = useTheme();

// Dynamically select background class
const backgroundClass = computed(() => {
  if (props.background) return props.background;
  return theme.global.current.value.dark ? 'genauth-background-dark' : 'genauth-background';
});
</script>

<template>
  <div class="main d-flex align-center justify-center bg-primary" :class="backgroundClass">
    <slot />
    <ThemeToggleFab />
  </div>
</template>

<style scoped>

</style>
